"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var PublishedDatasourceLineageUpstreamDataQualityWarningsQueryGql_1 = require("../../queries/PublishedDatasourceLineageUpstreamDataQualityWarningsQueryGql");
var ErrorListProvider_1 = require("../error/components/ErrorListProvider");
var renderQueryResult_1 = require("../renderQueryResult");
var DataQualityWarningCycleTemporaryFix_1 = require("./DataQualityWarningCycleTemporaryFix");
function EmbeddablePublishedDatasourceDataQualityWarning(props) {
    return (React.createElement(data_catalog_shared_1.VizPortalDQWDataCatalogProvider, __assign({}, props),
        React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(ErrorListProvider_1.ErrorListProvider, null,
                React.createElement(react_apollo_1.Query, { query: PublishedDatasourceLineageUpstreamDataQualityWarningsQueryGql_1.PublishedDatasourceLineageUpstreamDataQualityWarningsQueryGql, variables: { vizportalUrlId: props.vizportalUrlId, first: 10, offset: 0 } }, function (result) { return renderQueryResult_1.renderQueryResult(result, {
                    renderLoading: function () { return renderAnchoredWarning(false, props.ownContentWarnings); },
                    renderData: function (data) { return renderWarnings(urls, props.ownContentWarnings, data); },
                }); }));
        })));
}
exports.EmbeddablePublishedDatasourceDataQualityWarning = EmbeddablePublishedDatasourceDataQualityWarning;
function renderAnchoredWarning(iconOnly, warnings) {
    if (warnings.length === 0) {
        return null;
    }
    return React.createElement(data_catalog_shared_1.DataQualityStatusChip, { details: warnings, iconOnly: iconOnly });
}
function renderWarnings(urls, ownContentWarnings, data) {
    var _a, _b;
    var datasource = data && data.publishedDatasources ? data.publishedDatasources[0] : null;
    if (!datasource) {
        return null;
    }
    if (ownContentWarnings.length === 0 && ((_a = datasource.upstreamDataQualityWarningsConnection) === null || _a === void 0 ? void 0 : _a.totalCount) === 0) {
        return null;
    }
    var props = {
        urls: urls,
        iconOnly: false,
        anchoredWarnings: (ownContentWarnings !== null && ownContentWarnings !== void 0 ? ownContentWarnings : []),
        upstreamWarnings: DataQualityWarningCycleTemporaryFix_1.filterOutWarningsFromAnchorUntilCycleIsFixed(datasource.id, ((_b = datasource.upstreamDataQualityWarningsConnection) === null || _b === void 0 ? void 0 : _b.nodes) || DataQualityWarningCycleTemporaryFix_1.emptyWarnings)
    };
    return React.createElement(data_catalog_shared_1.RenderWarningsFromGraphAndVizportal, __assign({}, props));
}
//# sourceMappingURL=DataQualityWarningPublishedDatasources.js.map